<template>
  <div>



    <nav aria-label="Page Navigation">
      <ul class="pagination justify-content-center">
        <li :class=isInFirstPageClass>
          <a class="page-link" 
              @click="onClickPreviousPage"
              :disabled="isInFirstPage">Previous
          </a>
        </li>


        <li v-for="page in pages" :key="page"
          class="page-item">
          <a class="page-link" @click="onClickPage(page.name)"
              :disabled="page.isDisabled"
              :class="{ active: isPageActive(page.name) }">{{ page.name }}
          </a>
        </li>


        <li :class=isInLastPageClass>
          <a class="page-link" 
              @click="onClickNextPage"
              :disabled="isInLastPage">Next</a>
        </li>
      </ul>
    </nav>



    <!-- <ul class="pagination">
    <li class="pagination-item">
      <button
        type="button"
        @click="onClickFirstPage"
        :disabled="isInFirstPage"
      >
        First
      </button>
    </li>

    <li class="pagination-item">
      <button
        type="button"
        @click="onClickPreviousPage"
        :disabled="isInFirstPage"
      >
        Previous
      </button>
    </li> -->

    <!-- Visible Buttons Start -->

    <!-- <li
      v-for="page in pages" :key=page
      class="pagination-item">
      <button
        type="button"
        @click="onClickPage(page.name)"
        :disabled="page.isDisabled"
        :class="{ active: isPageActive(page.name) }">
        {{ page.name }}
      </button>
    </li> -->

    <!-- Visible Buttons End -->

    <!-- <li class="pagination-item">
      <button
        type="button"
        @click="onClickNextPage"
        :disabled="isInLastPage"
      >
        Next
      </button>
    </li>

    <li class="pagination-item">
      <button
        type="button"
        @click="onClickLastPage"
        :disabled="isInLastPage"
      >
        Last
      </button>
    </li>
  </ul> -->

  </div>
</template>

<script>
export default {
  props: {
    maxVisibleButtons: {
      type: Number,
      required: false,
      default: 3
    },    
    totalPages: {
      type: Number,
      required: true
    },
    perPage: {
      type: Number,
      required: true
    },
    currentPage: {
      type: Number,
      required: true
    }
  },
  computed: {
    startPage() {
      // When on the first page
      if (this.currentPage === 1) {
        return 1;
      }

      // When on the last page
      if (this.currentPage === this.totalPages) {
        return this.totalPages - this.maxVisibleButtons;
      }

      // When inbetween
      return this.currentPage - 1;
    },
    pages() {
      const range = [];

      for (
        let i = this.startPage;
        i <= Math.min(this.startPage + this.maxVisibleButtons - 1, this.totalPages);
        i++
      ) {
        range.push({
          name: i,
          isDisabled: i === this.currentPage
        });
      }

      return range;
    },
    isInFirstPage() {
      return this.currentPage === 1 ;
    },
    isInFirstPageClass() {
      return this.currentPage === 1 ? 'page-item disabled':'page-item';
    },
    isInLastPage() {
      return this.currentPage === this.totalPages;
    },
    isInLastPageClass() {
      return this.currentPage === this.totalPages ? 'page-item disabled':'page-item' ;
    }
  },
  methods: {
    onClickFirstPage() {
      this.$emit('pagechanged', 1);
    },
    onClickPreviousPage() {
      this.$emit('pagechanged', this.currentPage - 1);
    },
    onClickPage(page) {
      this.$emit('pagechanged', page);
    },
    onClickNextPage() {
      this.$emit('pagechanged', this.currentPage + 1);
    },
    onClickLastPage() {
      this.$emit('pagechanged', this.totalPages);
    },
    isPageActive(page) {
      return this.currentPage === page;
    }
  }
}
</script>

<style lang="scss">


.pagination {
  list-style-type: none;
}

.pagination-item {
  display: inline-block;
  
}

.active {
  background-color: #4AAE9B;
  color: #ffffff;
}

.page-link {cursor: pointer;}

</style>